import { LessonsExploreContainer } from "@features/modules/containers/LessonsExploreContainer";
import DocumentTitle from "components/DocumentTitle";

const ModulesRoute = () => {
	return (
		<>
			<DocumentTitle title="Modules" />
			<LessonsExploreContainer />
		</>
	);
};

export default ModulesRoute;
